import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { IssueActionModel } from '@ep-om/interfaces/ui-model/delete-issue-model';
import { ID } from '@common/interfaces/id';

@Component({
  selector: 'danger-action-modal',
  templateUrl: './danger-action-modal.component.html',
  styleUrls: ['./danger-action-modal.component.scss']
})
export class DangerActionModalComponent {
  issueId: ID;

  info: string = 'Questa azione è irreversibile.';
  actionName: string = 'Sì, confermo.';
  question: string = "Confermi l'operazione ?";
  onConfirm = new EventEmitter<IssueActionModel>()

  constructor(private _modalRef: NzModalRef) {}

  manageIssue() {
    this.onConfirm.emit(new IssueActionModel(this.issueId, this._modalRef));
    this._modalRef.triggerOk();
  }

  closeModal() {
    this._modalRef.close();
  }
}
